import styles from "./OverlappingIconGroup.module.scss"
import { OverlappingIconGroupProps } from "./OverlappingIconGroup.types"

export default function OverlappingIconGroup(props: OverlappingIconGroupProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
